export enum DrawerType {
  CREATE = "CREATE",
  EDIT = "EDIT",
}
